
import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Page.css';

function NotFound() {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="glitch" data-text="404">404</h1>
        <div className="page-card">
          <h2>Page Not Found</h2>
          <p>The page you are looking for does not exist.</p>
          <Link to="/" className="btn-glitch">Go Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
